import $t from '@Ravnur-Inc/l10n/$t';

import {
  FieldDescription$ThesaurusDescription,
  FieldDescription$Thesaurus,
} from '@/types/FieldDescription';

export { $t, $thesaurus };

function $thesaurus(
  desc: FieldDescription$ThesaurusDescription,
  group: string
): FieldDescription$Thesaurus {
  return desc.map(({ id, badge, tkey }) => {
    const label = $t(group, tkey);
    return { id, label, badge };
  });
}
